import React, { useState, useEffect } from "react";
import { IonGrid, IonRow, IonCol, IonAlert } from "@ionic/react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { getTimestamp } from "./timeStamp.js";
import { styles } from "../LoginStyles";
import "./LoginPopup.css";

const LoginPopup = (props) => {
  const routerProps = props.routerProps;
  const setShowTimeout = props.setShowTimeout;
  const startTimer = props.startTimer

  const [password, setPassword] = useState("");
  const [passwordCount, setPasswordCount] = useState(0);
  const [showError, setShowError] = useState(false);
  const [mfaCode, updateMFACode] = useState("");
  const [doMFA, setDoMFA] = useState(false)
  const [ , setMFASecret] = useState("")

  useEffect(()=>{
    if (passwordCount === 3) {
      setShowTimeout(false);
      localStorage.clear()
      routerProps.history.push("/logout");
    } else {
      if (passwordCount > 0){
      setShowError(true);
      setPassword("");
      }
    }
  },
  [passwordCount, routerProps, setShowTimeout])


  const refreshToken = () => {
    const body = JSON.stringify({
          email: localStorage.getItem('agent_username'),
          password: password,
          mfa_code: mfaCode
    });

    fetch(`https://${global.api_url}/agent/agentLogin.php?ts=${getTimestamp()}`, {
        method: "POST",
        body: body,
        headers: { partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
    })
        .then(res => res.json())
        .then(json => {
            

            if (json.status === "success") {

                if (json.mfa==="Y" && mfaCode==="") {

                  //should we do MFA?
                  setDoMFA(true)
                  setMFASecret(json.mfa_secret)

              } else {
                // localStorage.setItem("pingTime", new Date())
                localStorage.setItem("agentToken", json.token);
                setPassword("");
                setShowTimeout(false);
                setPasswordCount(0)
                startTimer()
              }
            } else {
              setPasswordCount(passwordCount + 1);
            }
         
        });
}




  // const refreshToken = () => {

  //   const body = JSON.stringify({
  //     email: localStorage.getItem('username'),
  //     password: password,
  //   });

  //   fetch(`https://${global.api_url}/getToken.php?ts=${getTimestamp()}`, {
  //     method: "POST",
  //     body: body,
  //     headers: { partnerId: global.partner_id },
  //   })
  //     .then((res) => res.json())
  //     .then((json) => {
  //       if (json.status === "success") {
  //         localStorage.setItem("token", json.token);
  //         setPassword("");
  //         setShowTimeout(false);
  //         startTimer()
  //       } else {
  //         setPasswordCount(passwordCount + 1);
  //         if (passwordCount === 3) {
  //           setShowTimeout(false);
  //           routerProps.history.push("/logout/logout");
  //         } else {
  //           setShowError(true);
  //           setPassword("");
  //         }
  //       }
  //     });
  // };

  const handleKeyDownPassword = (e) => {
    if (e.key === "Enter") {
      refreshToken();
    }
  };

  return (
    <div class="container">
      <div class="modal">
        <div
          style={{
            marginTop: 20,
            marginBottom: 20,
            flex: 0.6,
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <img
            style={{
              width: "100%",
              paddingLeft: -40,
              paddingTop: 20,
            }}
            alt=""
            src={require("../images/untied-white-logo.png").default}
          />
        </div>


        {doMFA ? 
          (
                  
            <div>
        
              <p style={{ color: 'white' }}>Please enter authentication code:</p>

              <TextField
                  style={styles.input}
                  //onKeyPress={handleKeyDownSecret}
                  autoCapitalize="none"
                  value={mfaCode}
                  onChange={event => updateMFACode(event.target.value)}
                  type="password"
                  placeholder="Code"
                  margin="none"
                  InputProps={{ disableUnderline: true }}
              />

            </div>

          ) : (
          
            <div>

                <p style={{ color: "white" }}>Enter your password to continue where you left off</p>

                <TextField
                  id="inputFocus"
                  autoFocus
                  style={styles.input}
                  autoCapitalize="none"
                  type="password"
                  value={password}
                  onKeyPress={handleKeyDownPassword}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                  returnkeytype="next"
                  placeholder="Password"
                  margin="none"
                  InputProps={{ disableUnderline: true }}
                />
            </div>
          )
        }

        <IonGrid style={{ paddingTop: 10, marginLeft: 0, marginRight: 0 }}>
          <IonRow>
            <IonCol style={{ paddingLeft: 0, paddingRight: 5 }}>
              <Button
                style={styles.buttonContainer2}
                size="small"
                onClick={() => {
                  setShowTimeout(false);
                  routerProps.history.push("/logout/logout");
                }}
              >
                Log out
              </Button>
            </IonCol>

            <IonCol style={{ paddingLeft: 5, paddingRight: 0 }}>
              <Button
                style={styles.buttonContainer}
                size="small"
                onClick={() => {
                  refreshToken();
                }}
              >
                Log in
              </Button>
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonAlert
          isOpen={showError}
          onDidDismiss={() => setShowError(false)}
          header={"Wrong password"}
          subHeader={""}
          message={"You have entered an incorrect password. Please try again."}
          buttons={["OK"]}
        />
      </div>
    </div>
  );
};

export default LoginPopup;